import { ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { ParseRequestsStore } from '../stores/parse-requests.store';

export const parseRequestLoadedGuard = async (route: ActivatedRouteSnapshot) => {
  const parseRequestsStore = inject(ParseRequestsStore);
  const parseRequestId = route.paramMap.get('parseRequestId');
  if (!parseRequestId) {
    return false;
  }

  if (parseRequestsStore.parseRequests()?.some((ei) => ei.id === parseRequestId)) {
    return true;
  }
  // We explicitly do not await the loading here to allow the router to proceed immediately.
  // This enables the target component to handle and display its own loading and error states,
  // providing a better user experience (e.g., showing skeletons instead of a blank screen).
  parseRequestsStore.loadItem(parseRequestId);
  return true;
};
